import { useMemo } from "react"

import useRewardsUserSelectStore from "./hooks/useRewardsUserSelectStore"
import UserSelectHeader from "../../components/userSelectHeader/UserSelectHeader"
import { useScreenTimeCurrentExceptionQuery } from "../../networking/rewards/queries"
import { UserSelectFilterType } from "../../types"

const RewardsUserSelectHeader = () => {
  const {
    selectedUserId,
    selectedFilterType,
    setSelectedUserId,
    setSelectedFilterType,
  } = useRewardsUserSelectStore()
  const { data: exceptions } = useScreenTimeCurrentExceptionQuery()
  const restrictedScreenTimeUserIds = useMemo(
    () => Object.keys(exceptions || {}).map(Number) || [],
    [exceptions]
  )

  const onUserSelect = (
    filterType: UserSelectFilterType,
    userId: number | null
  ) => {
    if (filterType === UserSelectFilterType.USER) {
      setSelectedFilterType(UserSelectFilterType.USER)
      setSelectedUserId(userId)
    } else {
      setSelectedFilterType(filterType)
      setSelectedUserId(null)
    }
  }

  return (
    <UserSelectHeader
      selectedUserId={selectedUserId}
      onUserSelect={onUserSelect}
      selectedFilterType={selectedFilterType}
      showAllOption={false}
      showAllKidsOption={true}
      showMeOption={false}
      showCoparents={false}
      showAllKidsOptionAlways={true}
      restrictedScreenTimeUserIds={restrictedScreenTimeUserIds}
    />
  )
}

export default RewardsUserSelectHeader
